import removeDuplicateValues from '../operator/removeDuplicateValues';
import removeDuplicateIndices from '../operator/removeDuplicateIndices';
import removeInvalidSurfaces from '../operator/removeInvalidSurfaces';
import removeDuplicateNormals from '../operator/removeDuplicateNormals';

export default function cleanPolyMesh(polyMesh) {
  //not advisable to remove normals by default. can lead to fusing of normals on joints while doing animation
  //return removeDuplicateNormals(removeInvalidSurfaces(removeDuplicateIndices(removeDuplicateValues(polyMesh))));
  return removeInvalidSurfaces(removeDuplicateIndices(removeDuplicateValues(polyMesh)));
}



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/cleanPolyMesh.js